import { connect } from 'react-redux';
import type { ThunkDispatch } from 'state/state.common';
import { workspaceSharableQuoteLoadRequested } from 'state/workspaces/workspace.actions';

export interface LoadRfqRouteProps {
  onLoadRfq(rfqId: string): void;
}

const mapDispatchToProps = (dispatch: ThunkDispatch): LoadRfqRouteProps => {
  return {
    onLoadRfq(rfqId) {
      dispatch(workspaceSharableQuoteLoadRequested(rfqId));
    },
  };
};

export const connectLoadRfqRoute = connect(undefined, mapDispatchToProps);
